import "../portfolio/insDeletePortfolioAction.scss";
import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum, AuxButtonSizeEnum } from "@blk/aladdin-web-components";
import { isEqual } from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { insMarketsstateId } from "./markets";
import { MessagesDialogFunctionName } from "components/frame/helper";
import { language } from "language/default";
import { setMessagesDialog } from "store/messages-dialog";
export const InsDeleteBenchmarksAction = (props) => {
    const selectedRows = useSelector((state) => state.grids.state[insMarketsstateId]?.selectedRows, isEqual) ?? [];
    const dispatch = useDispatch();
    return React.createElement(AuxButton, { size: AuxButtonSizeEnum.SMALL, type: AuxButtonTypeEnum.DESTRUCTIVE_PRIMARY, isDisabled: selectedRows.length === 0, onClick: () => {
            if (selectedRows?.length) {
                dispatch(setMessagesDialog({ functionName: MessagesDialogFunctionName.DeleteBenchmark,
                    hasCustomFooter: true,
                    messages: [{ message: language.en.modal.benchmarkCreation.benchmarkDeletion.deleteBenchmarkAlertFirstLine }],
                    title: language.en.modal.benchmarkCreation.benchmarkDeletion.deleteBenchmarkAlertHeader,
                    type: "alert-with-options" }));
            }
            props.refresh();
        }, label: language.en.modal.benchmarkCreation.benchmarkDeletion.deleteBenchmark });
};
